import React from "react"
export default function ButtonBlue({ buttonText, btnClass }: { buttonText?: string, btnClass?: string }) {
  return (
    <>
      <button type='submit' className={`btn ${btnClass}`}>{buttonText}</button>
    </>
  )
}
